import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Flower2 } from 'lucide-react';

export const Navigation = () => {
    const location = useLocation();
    
    const isActive = (path) => {
        return location.pathname === path;
    };
    
    return (
        <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
                <div className="flex items-center justify-between h-20">
                    {/* Logo */}
                    <Link to="/" className="flex items-center gap-3 group">
                        <div className="relative">
                            <Flower2 className="w-8 h-8 text-primary transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12" />
                            <div className="absolute inset-0 bg-primary/20 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                        </div>
                        <span className="text-2xl font-serif font-medium text-foreground tracking-wide">
                            Focus Bloom
                        </span>
                    </Link>
                    
                    {/* Navigation Links */}
                    <div className="flex items-center gap-2 sm:gap-4">
                        <Link
                            to="/"
                            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                                isActive('/')
                                    ? 'bg-primary text-primary-foreground shadow-md'
                                    : 'text-foreground hover:bg-muted hover:text-foreground'
                            }`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/exercises"
                            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                                isActive('/exercises')
                                    ? 'bg-primary text-primary-foreground shadow-md'
                                    : 'text-foreground hover:bg-muted hover:text-foreground'
                            }`}
                        >
                            Exercises
                        </Link>
                        <Link
                            to="/about"
                            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                                isActive('/about')
                                    ? 'bg-primary text-primary-foreground shadow-md'
                                    : 'text-foreground hover:bg-muted hover:text-foreground'
                            }`}
                        >
                            About
                        </Link>
                        <Link
                            to="/contact"
                            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                                isActive('/contact')
                                    ? 'bg-primary text-primary-foreground shadow-md'
                                    : 'text-foreground hover:bg-muted hover:text-foreground'
                            }`}
                        >
                            Contact
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
};